import React, {useState} from "react";
import {Button, Row, Col, Modal, notification} from "antd";
import '../modals.css';
import PhoneField from "../../phone-field";
import {userServices} from "../../../services";
import DividerBlock from "../../divider-block";
import InputField from "../../input-field";
import i18n from "../../../i18n";

export default function ModalChangeUserProfile({
                                               isShow, id, setIsShow, setNeedUpdateList, currentEmail, currentName
                                             }) {
  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };
  const [newLoginCountryID, setNewLoginCountryID] = useState("");
  const [newLogin, setNewLogin] = useState("");
  const [email, setEmail] = useState(currentEmail);
  const [name, setName] = useState(currentName);
  const [isDisabled, setIsDisabled] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState({});

  const handleChangeProfile = () => {
      userServices.changeProfile(name, email, id)
          .then(resp => {
              setFieldsErrors([]);
              if (resp.status === 'success') {
                  notification.success({
                      message: i18n.t('components.notification.titles.changeProfile'),
                      description: resp.message,
                  });
              } else if (resp.status === 'error') {
                  setFieldsErrors(resp.errors);
              }
          })
          .catch(err => {
              notification.error({
                  message: i18n.t('components.notification.titles.changeProfile'),
                  description: err,
              });
          })
          .finally();
  };

  const onSignUp = () => {
    setIsDisabled(true);
    userServices.changeUserLogin(id, newLogin, newLoginCountryID)
      .then((response) => {
        if(response.code !== 400) {
          notification.success({
            message: i18n.t('components.notification.titles.changeUserLogin'), description: response.message,
          });
          setIsShow(false);
          setNeedUpdateList(true);
        } else {
          setFieldsErrors(response.errors)
        }

      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.changeUserLogin'), description: err,
        });
      })
      .finally(() => {
        setIsDisabled(false);
      })
  }

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField]
      : null;
  };

  return (<Modal
    title={<div>{i18n.t('modals.modalChangeUserProfile.title')}</div>}
    cancelText={i18n.t('main.buttons.close')}
    className="modal-window"
    align={null}
    visible={isShow}
    onCancel={() => {
      setIsShow(false);
    }}
    forceRender={true}
    footer=""
  >
    <DividerBlock label={i18n.t('modals.modalChangeUserProfile.divider.user')} />
    <Row gutter={[16, 24]}>
        <Col lg={12}>
            <InputField
                name="name"
                label={i18n.t('modals.modalChangeUserProfile.fields.name.title')}
                getFieldErrors={getFieldErrors}
                value={name}
                setValue={setName}
            />
        </Col>
        <Col lg={12}>
            <InputField
                name="email"
                label={i18n.t('modals.modalChangeUserProfile.fields.email.title')}
                getFieldErrors={getFieldErrors}
                value={email}
                setValue={setEmail}
            />
        </Col>
    </Row>
    <Row gutter={[16, 24]}>
        <Col lg={6}>
            <Button
                type="primary"
                htmlType="button"
                onClick={handleChangeProfile}
                size="small"
                style={bigButtonStyle}
            >
              {i18n.t('modals.modalChangeUserProfile.buttons.changeProfile')}
            </Button>
        </Col>
    </Row>
    <DividerBlock label={i18n.t('modals.modalChangeUserProfile.divider.login')} />
    <Row>
      <Col>
        <PhoneField
          getErrors={getFieldErrors}
          countryFieldName="newLoginCountryID"
          countryFieldWidth="104px"
          phoneFieldName="newLogin"
          phoneFieldWidth="200px"
          title={i18n.t('modals.modalChangeUserProfile.fields.newLogin.title')}
          className="phone"
          selectedCountryID={newLoginCountryID}
          onChangeCountry={(value) => {
            setNewLoginCountryID(value);
          }}
          phoneNumber={newLogin}
          onChangePhone={(e) => {
            setNewLogin(e.target.value);
          }}
        />
      </Col>
    </Row>
    <Row gutter={[16, 24]}>
        <Col lg={6}>
            <Button htmlType="submit" key="submit" type="primary"
                    style={bigButtonStyle}
                    onClick={() => onSignUp()}
                    disabled={newLoginCountryID === "" || newLogin === "" || isDisabled}
            >{i18n.t('modals.modalChangeUserProfile.buttons.changeLogin')}</Button>
        </Col>
    </Row>
  </Modal>);
}
